import React, { useState } from 'react';
import { Modal, Button } from 'reactstrap';

import { ConversationCard } from './components/Card';

const ConversationDetails = ({
  conversationData,
  getDataOnModalOpen = false,
  disabled = false,
  id = '',
  chatIdToBeSearched = '',
  buttonText = null,
  buttonSize = 'sm',
  buttonColor = 'success',
  useIcon = false
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const renderButtonContent = () => {
    if (useIcon) {
      return <i className={'fas fa-comments'}></i>;
    }
    if (buttonText) {
      return buttonText;
    }
    return <i className={'fas fa-info-circle'}></i>;
  };

  const getTitle = () => {
    if (useIcon) {
      return 'Exibir conversa';
    }
    if (buttonText) {
      return buttonText;
    }
    return 'Detalhes';
  };

  return (
    <>
      <Button
        color={buttonColor}
        size={buttonSize}
        title={getTitle()}
        onClick={toggleModal}
        disabled={disabled}
        id={`${id}-conversation-details`}
        type="button"
      >
        {renderButtonContent()}
      </Button>
      <Modal
        backdrop={true}
        isOpen={isModalOpen}
        toggle={() => toggleModal()}
        centered={true}
      >
        <ConversationCard
          conversationData={conversationData}
          getDataOnModalOpen={getDataOnModalOpen}
          chatIdToBeSearched={chatIdToBeSearched}
        />
      </Modal>
    </>
  );
};

export default ConversationDetails;
